import React, { useMemo } from 'react';

import { Flex } from '@adsk/alloy-react-box';
import Dropdown, { GenericItem } from '@adsk/alloy-react-dropdown';
import FormField from '@adsk/alloy-react-form-field';

import { useTranslation } from '../../i18n';
import { DropdownSingleSelectProps, QuickLookFilters } from '../../types';

function QuickLookFilter({
  backFilter,
  aheadFilter,
  onChange,
}: {
  backFilter?: QuickLookFilters;
  aheadFilter?: QuickLookFilters;
  onChange: (key: string, value: (QuickLookFilters | undefined)[]) => void;
}) {
  const { t } = useTranslation();
  const viewRangeOptions = useMemo(
    () =>
      Object.keys(QuickLookFilters).map((rangeOption) => ({
        label: t(`FILTERS.${rangeOption}`),
        value: rangeOption,
      })),
    [t],
  );

  const backFilterValue =
    useMemo(
      () => viewRangeOptions.find((item) => item?.value === backFilter),
      [backFilter, viewRangeOptions],
    ) ?? null;

  const aheadFilterValue =
    useMemo(
      () => viewRangeOptions.find((item) => item?.value === aheadFilter),
      [aheadFilter, viewRangeOptions],
    ) ?? null;

  const onChangeFilter = (index: number, value?: QuickLookFilters) => {
    const quickLook = [backFilter, aheadFilter];
    quickLook[index] = value;
    onChange('quickLook', quickLook);
  };

  const handleQuickFilterChange = (
    index: number = 0,
    selectedItem: GenericItem | null,
  ) => {
    const value = selectedItem?.value?.toString() || '';
    if (QuickLookFilters?.valueOf()?.hasOwnProperty(value)) {
      onChangeFilter(index, value as QuickLookFilters);
    }
  };

  const handleLookBackSelectChange = ({
    selectedItem = {},
  }: DropdownSingleSelectProps) => {
    handleQuickFilterChange(0, selectedItem);
  };

  const handleLookHeadSelectChange = ({
    selectedItem = {},
  }: DropdownSingleSelectProps) => {
    handleQuickFilterChange(1, selectedItem);
  };

  return (
    <Flex
      padding="24px 0"
      style={{
        gap: '8px 16px',
      }}
    >
      <FormField
        label={t('FILTERS.LOOK_BACK')}
        labelVariant={FormField.LABEL_VARIANTS.TOP}
      >
        <Dropdown
          style={{ width: '100%' }}
          items={viewRangeOptions}
          selectedItem={backFilterValue}
          onSelectedItemChange={handleLookBackSelectChange}
        />
      </FormField>
      <FormField
        label={t('FILTERS.LOOK_AHEAD')}
        labelVariant={FormField.LABEL_VARIANTS.TOP}
      >
        <Dropdown
          style={{ width: '100%' }}
          items={viewRangeOptions}
          selectedItem={aheadFilterValue}
          onSelectedItemChange={handleLookHeadSelectChange}
        />
      </FormField>
    </Flex>
  );
}

export default QuickLookFilter;
